import { Box, Typography } from '@mui/material';
import cx from 'clsx';

import { TechStackItem } from '@/config/tech-stack.config';

import styles from './TechCard.module.scss';

interface TechCardProps {
  tech: TechStackItem;
}

const TechCard = ({ tech }: TechCardProps) => {
  const { name, icon: Icon, background, isDark } = tech;

  return (
    <Box className={styles.container} style={{ background }}>
      <Box className={styles.iconWrapper}>
        <Icon />
      </Box>
      <Typography variant="body3" className={cx(styles.name, { [styles.dark]: isDark })}>
        {name}
      </Typography>
      {isDark && <Box className={styles.gradient} />}
    </Box>
  );
};

export default TechCard;
